let data = [];
const stateLocationsData = {
		Alabama :{ lat: 32.806671, lng: -86.79113 },
		Alaska :{ lat: 61.370716, lng: -152.404419 },
		Arizona :{ lat: 33.729759, lng: -111.431221 },
		Arkansas :{ lat: 34.969704, lng: -92.373123 },
		California :{ lat: 36.116203, lng: -119.681564 },
		Colorado :{ lat: 39.059811, lng: -105.311104 },
		Connecticut :{ lat: 41.597782, lng: -72.755371 },
		Delaware :{ lat: 39.318523, lng: -75.507141 },
		DistrictofColumbia :{ lat: 38.897438, lng: -77.026817 },
		Florida :{ lat: 27.766279, lng: -81.686783 },
		Georgia :{ lat: 33.040619, lng: -83.643074 },
		Hawaii :{ lat: 21.094318, lng: -157.498337 },
		Idaho :{ lat: 44.240459, lng: -114.478828 },
		Illinois :{ lat: 40.349457, lng: -88.986137 },
		Indiana :{ lat: 39.849426, lng: -86.258278 },
		Iowa :{ lat: 42.011539, lng: -93.210526 },
		Kansas :{ lat: 38.5266, lng: -96.726486 },
		Kentucky :{ lat: 37.66814, lng: -84.670067 },
		Louisiana :{ lat: 31.169546, lng: -91.867805 },
		Maine :{ lat: 44.693947, lng: -69.381927 },
		Maryland :{ lat: 39.063946, lng: -76.802101 },
		Massachusetts :{ lat: 42.230171, lng: -71.530106 },
		Michigan :{ lat: 43.326618, lng: -84.536095 },
		Minnesota :{ lat: 45.694454, lng: -93.900192 },
		Mississippi :{ lat: 32.741646, lng: -89.678696 },
		Missouri :{ lat: 38.456085, lng: -92.288368 },
		Montana :{ lat: 46.921925, lng: -110.454353 },
		Nebraska :{ lat: 41.12537, lng: -98.268082 },
		Nevada :{ lat: 38.313515, lng: -117.055374 },
		NewHampshire :{ lat: 43.452492, lng: -71.563896 },
		NewJersey :{ lat: 40.298904, lng: -74.521011 },
		NewMexico :{ lat: 34.840515, lng: -106.248482 },
		NewYork :{ lat: 42.165726, lng: -74.948051 },
		NorthCarolina :{ lat: 35.630066, lng: -79.806419 },
		NorthDakota :{ lat: 47.528912, lng: -99.784012 },
		Ohio :{ lat: 40.388783, lng: -82.764915 },
		Oklahoma :{ lat: 35.565342, lng: -96.928917 },
		Oregon :{ lat: 44.572021, lng: -122.070938 },
		Pennsylvania :{ lat: 40.590752, lng: -77.209755 },
		RhodeIsland :{ lat: 41.680893, lng: -71.51178 },
		SouthCarolina :{ lat: 33.856892, lng: -80.945007 },
		SouthDakota :{ lat: 44.299782, lng: -99.438828 },
		Tennessee :{ lat: 35.747845, lng: -86.692345 },
		Texas :{ lat: 31.054487, lng: -97.563461 },
		Utah :{ lat: 40.150032, lng: -111.862434 },
		Vermont :{ lat: 44.045876, lng: -72.710686 },
		Virginia :{ lat: 37.769337, lng: -78.169968 },
		Washington :{ lat: 47.400902, lng: -121.490494 },
		WestVirginia :{ lat: 38.491226, lng: -80.954453 },
		Wisconsin :{ lat: 44.268543, lng: -89.616508 },
		Wyoming :{ lat: 42.755966, lng: -107.30249 }
  };

const storeDataLocal = {
  "Stores": [
    {
      "Name": "221 INC",
      "Address": "18729 Fir Island Rd, Mt Vernon, WA 98273, United States",
      "Phone Number": "(360) 445-6221",
      "Email": "info@221inc.com",
      "Website": "http://prcconway.com/",
      "LogoImage": "http://happyapple.com/wp-content/sabai/File/thumbnails/63d996ad9ab3b0b285ef3d433e630db7.png",
      "Latitude": "48.341610",
      "Longitude": "-122.340740"
    },
    {
      "Name": "FIRE CANNABIS COMPANY",
      "Address": "903 Engh Rd Suite D Omak, WA",
      "Phone Number": "(509) 557-6420",
      "LogoImage": "http://happyapple.com/wp-content/sabai/File/thumbnails/9be8d8eac172d1b47333581c352fbd55.png",
      "Latitude": "48.417246",
      "Longitude": "-119.506529"
    },
    {
      "Name": "2020 SOLUTIONS EPHRATA",
      "Address": "1615 Basin St SW, Ephrata, WA 98823",
      "Phone Number": "(877) 934-2020",
      "Email": "purchasing@i502solutions.com",
      "Website": "https://www.2020ephrata.com",
      "Latitude": "47.304850",
      "Longitude": "-119.563250"
    },
    {
      "Name": "The Urban Farmacy",
      "Address": "420 NE 60th Ave Portland, OR 97213",
      "Phone Number": "(503) 957-7832",
      "Website": "https://www.urbanfarmacypdx.com/",
      "Latitude": "45.5260766",
      "Longitude": "-122.60205930000001"
    }
  ]
};

const mapStyleLocal = [{"featureType":"administrative","elementType":"labels.text","stylers":[{"lightness":"15"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"saturation":"-100"},{"lightness":"23"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":"35"},{"lightness":"46"},{"gamma":1},{"hue":"#6dff00"}]},{"featureType":"landscape.natural.terrain","elementType":"all","stylers":[{"lightness":"16"}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#78ff00"},{"saturation":"22"},{"lightness":"50"},{"gamma":1}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"lightness":"-27"},{"weight":"0.76"},{"saturation":"0"}]},{"featureType":"road","elementType":"all","stylers":[{"lightness":"21"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"lightness":"-12"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"hue":"#0011ff"},{"saturation":"-84"},{"lightness":"59"},{"gamma":1},{"weight":"0.50"}]},{"featureType":"road.highway.controlled_access","elementType":"all","stylers":[{"lightness":"0"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"hue":"#ff0300"},{"saturation":-100},{"lightness":51.19999999999999},{"gamma":1}]},{"featureType":"road.local","elementType":"all","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":52},{"gamma":1}]},{"featureType":"transit","elementType":"all","stylers":[{"lightness":"7"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#009dff"},{"saturation":"-2"},{"lightness":"10"},{"gamma":1}]}];

const googleMapsAPIDefault = 'AIzaSyA0dkNmK3tv3OUBBi4-Wgv2wjwojeFGlRw';

data['stateLocationsData'] = stateLocationsData;
data['storeDataLocal'] = storeDataLocal;
data['mapStyleLocal'] = mapStyleLocal;
data['googleMapsAPIDefault'] = googleMapsAPIDefault;

// data.push(storeDataLocal);
// data.push(mapStyleLocal);
// data.push(googleMapsAPIDefault);

export default data;



// WEBPACK FOOTER //
// ./src/js/extra-data.js